import React, { useMemo } from 'react';
import { Badge } from '@mantine/core';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { getMeasurementDetailListQuery } from '../../../../slices/measurementDetail/thunk';

const WorkMeasurementDetailsGrid = ({ workOrderId }) => {
	// DD/MM/YYYY
	const formatDate = dateString => {
		if (!dateString) return '-';
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return '-';
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		return `${day}/${month}/${year}`;
	};

	// Format numeric values with fixed decimals
	const formatNumber = (value, decimals = 2) => {
		if (value === null || value === undefined) return '-';
		return Number(value).toFixed(decimals);
	};

	// measurement_status.name → Badge color
	const getStatusColor = name => {
		if (!name) return 'gray';
		switch (name) {
			case 'Cumple':
				return 'green';
			case 'Bajo':
				return 'yellow';
			case 'Medio':
				return 'yellow';
			case 'No cumple':
				return 'red';
			case 'En espera de resultados':
				return 'cyan';
			default:
				return 'gray';
		}
	};

	const columns = useMemo(
		() => [
			{
				header: 'Estado',
				dataType: 'select',
				accessorKey: 'measurement_status.name',
				Cell: cellProps => {
					const name = cellProps.row.original.measurement_status?.name;
					return (
						<Badge color={getStatusColor(name)} tt='capitalize'>
							{name || '-'}
						</Badge>
					);
				},
			},
			{
				header: 'Fecha Medición',
				dataType: 'date',
				accessorKey: 'measurement_date',
				Cell: cellProps => {
					return <span>{formatDate(cellProps.row.original.measurement_date)}</span>;
				},
			},
			{
				header: 'Hora Medición',
				dataType: 'string',
				accessorKey: 'measurement_time',
			},
			{
				header: 'Caudal (L/s)',
				dataType: 'float.2',
				accessorKey: 'flow_rate',
				Cell: cellProps => {
					return <span>{formatNumber(cellProps.row.original.flow_rate)}</span>;
				},
			},
			{
				header: 'Límite Caudal (L/s)',
				dataType: 'float.2',
				accessorKey: 'flow_rate_limit',
				Cell: cellProps => {
					return <span>{formatNumber(cellProps.row.original.flow_rate_limit)}</span>;
				},
			},
			{
				header: 'Totalizador (m³)',
				dataType: 'float.2',
				accessorKey: 'totalizer',
				Cell: cellProps => {
					return <span>{formatNumber(cellProps.row.original.totalizer)}</span>;
				},
			},
			{
				header: 'Nivel Freático (m)',
				dataType: 'float.2',
				accessorKey: 'water_table_level',
				Cell: cellProps => {
					return <span>{formatNumber(cellProps.row.original.water_table_level)}</span>;
				},
			},
		],
		[formatDate]
	);

	if (!workOrderId) return null;

	return (
		<ODataGrid
			columns={columns}
			getDataFunc={getMeasurementDetailListQuery}
			baseFilters={{
				work_order_id: { $eq: workOrderId },
				disable: { $eq: false },
			}}
			remoteOperations={{
				pagination: true, 
				sorting: true, 
				filtering: true 
			}}
			queryPopulate={[
				'measurement_status', 
				'scheduled_activity', 
				'work_order'
			]}
			getRowIdTable={row => row._id}
			nameFile='Detalle de Mediciones'
		/>
	);
};

export default WorkMeasurementDetailsGrid;

